export default (function (container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return container || defaultContainer;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-lib/es/query/getContainer.js
// module id = 2168
// module chunks = 33